import { useCssModule, ref, computed } from "vue";
import { u as useI18n } from "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { X as XIcon } from "./assets/XIcon-U9bwokTN.js";
import XLink from "./XLink.js";
import XButton from "./XButton.js";
import { X as XDropdown } from "./assets/XDropdown-CrQavYks.js";
import XListItem from "./XListItem.js";
import XEllipsis from "./XEllipsis.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "@fortawesome/vue-fontawesome";
import "./assets/index-DKxr0Yto.js";
import "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-Ca8wHgNc.js";
import "./assets/index-4vIud5LZ.js";
import "./assets/index-D0Qy8ijJ.js";
import "./XSpinner.js";
import "@floating-ui/dom";
import "./assets/index-BWUsUM8p.js";
import "./assets/SingleInput-CTOYPcHF.js";
import "./assets/index-Df_FM1j-.js";
import "./assets/index-BJV0_gaH.js";
import "./XCheckbox.js";
import "./BaseOption.js";
import "./XFormField.js";
import "./assets/SingleMessage-Dv2wNb7f.js";
import "./XTooltip.js";
import "./BasicContent.js";
import "./ContentBox.js";
import "./CloseButton.js";
import "./AdvancedContent.js";
import "./MessagesContainer.js";
import "./MultipleInputs.js";
function trimString(string, maxLength = 16) {
  if (string.length <= maxLength) return string;
  const ellipsisLength = 3;
  const trimLength = Math.floor((maxLength - ellipsisLength) / 2);
  const stringStartHalf = string.substring(0, trimLength);
  const stringEndHalf = string.substring(string.length - trimLength - 1);
  const trimmedString = `${stringStartHalf}...${stringEndHalf}`;
  return trimmedString;
}
const xBreadcrumb = "_xBreadcrumb_tbhga_1";
const xBreadcrumbChevron = "_xBreadcrumbChevron_tbhga_9";
const xBreadcrumbCol = "_xBreadcrumbCol_tbhga_13";
const isMenuOpen = "_isMenuOpen_tbhga_20";
const xBreadcrumbMenuCol = "_xBreadcrumbMenuCol_tbhga_24";
const xBreadcrumbDropdown = "_xBreadcrumbDropdown_tbhga_31";
const xBreadcrumbMenu = "_xBreadcrumbMenu_tbhga_24";
const xBreadcrumbMenuItem = "_xBreadcrumbMenuItem_tbhga_43";
const xBreadcrumbPreviousTitle = "_xBreadcrumbPreviousTitle_tbhga_52";
const xBreadcrumbPreviousTitleLink = "_xBreadcrumbPreviousTitleLink_tbhga_59";
const xBreadcrumbPreviousTitleText = "_xBreadcrumbPreviousTitleText_tbhga_65";
const xBreadcrumbCurrentTitle = "_xBreadcrumbCurrentTitle_tbhga_69";
const xBreadcrumbCurrentTitleText = "_xBreadcrumbCurrentTitleText_tbhga_78";
const style0 = {
  xBreadcrumb,
  xBreadcrumbChevron,
  xBreadcrumbCol,
  isMenuOpen,
  xBreadcrumbMenuCol,
  xBreadcrumbDropdown,
  xBreadcrumbMenu,
  xBreadcrumbMenuItem,
  xBreadcrumbPreviousTitle,
  xBreadcrumbPreviousTitleLink,
  xBreadcrumbPreviousTitleText,
  xBreadcrumbCurrentTitle,
  xBreadcrumbCurrentTitleText
};
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "XBreadCrumb",
  components: {
    XIcon,
    XLink,
    XDropdown,
    XListItem,
    XButton,
    XEllipsis
  }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    paths: {
      type: Array,
      required: true
    },
    ...createTestIdProp()
  },
  setup(__props) {
    const props = __props;
    const $style = useCssModule();
    const { formatTestId } = setupTestId(props);
    const isMenuOpen2 = ref(false);
    const { t } = useI18n();
    const openMenu = () => {
      isMenuOpen2.value = true;
    };
    const closeMenu = () => {
      isMenuOpen2.value = false;
    };
    const computedPaths = computed(
      () => props.paths.map((path, index) => ({
        ...path,
        trimmedTitle: trimString(path.name),
        level: index
      }))
    );
    const dropdownPaths = computed(() => computedPaths.value.slice(0, -2));
    const currentPath = computed(() => computedPaths.value[computedPaths.value.length - 1]);
    const previousPath = computed(() => computedPaths.value[computedPaths.value.length - 2]);
    const activatorButtonClass = computed(() => ({
      [$style.isMenuOpen]: isMenuOpen2.value
    }));
    function hasDropdownPaths() {
      var _a;
      return ((_a = dropdownPaths.value) == null ? void 0 : _a.length) > 0;
    }
    return { __sfc: true, createTestIdProp, setupTestId, props, $style, formatTestId, isMenuOpen: isMenuOpen2, t, openMenu, closeMenu, computedPaths, dropdownPaths, currentPath, previousPath, activatorButtonClass, hasDropdownPaths, XIcon, XLink, XButton, XDropdown, XListItem, XEllipsis };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: _setup.$style.xBreadcrumb, attrs: { "data-testid": _setup.formatTestId() } }, [_c("div", { class: _setup.$style.xBreadcrumbCol }, [_setup.hasDropdownPaths() ? _c("span", { class: _setup.$style.xBreadcrumbMenuCol, attrs: { "data-testid": _setup.formatTestId("dropdownContainer") } }, [_c(_setup.XDropdown, { attrs: { "placement": "bottom-start", "data-testid": _setup.formatTestId("dropdown"), "dropdown-classes": [_setup.$style.xBreadcrumbDropdown] }, on: { "focus": _setup.openMenu, "blur": _setup.closeMenu }, scopedSlots: _vm._u([{ key: "activator", fn: function({ on }) {
    return [_c(_setup.XButton, { class: [_setup.activatorButtonClass], attrs: { "border-radius": "circle", "size": "sm", "design": "outlined", "title": _setup.t("ds.XBreadCrumb.actions.openMenu"), "data-testid": _setup.formatTestId("menuButton") }, on: { "click": on } }, [_c(_setup.XIcon, { attrs: { "icon-style": "fas", "icon": "ellipsis-h" } })], 1)];
  } }], null, false, 1009363239) }, [_c("ul", { class: _setup.$style.xBreadcrumbMenu, attrs: { "data-testid": _setup.formatTestId("menu") } }, _vm._l(_setup.dropdownPaths, function(item) {
    return _c("li", { key: item.name }, [_c(_setup.XLink, { class: _setup.$style.xBreadcrumbMenuItem, attrs: { "to": item.to, "title": item.name, "size": "small", "no-underline": "", "data-testid": _setup.formatTestId(`dropdown-${item.name}-link`) } }, [_c(_setup.XListItem, { attrs: { "icon": item.icon, "level": item.level } }, [_vm._v(" " + _vm._s(item.trimmedTitle) + " ")])], 1)], 1);
  }), 0)]), _c(_setup.XIcon, { class: _setup.$style.xBreadcrumbChevron, attrs: { "icon": "chevron-right", "size": "xs" } })], 1) : _vm._e(), _setup.previousPath ? _c("span", { class: _setup.$style.xBreadcrumbPreviousTitle, attrs: { "data-testid": _setup.formatTestId("previousPath") } }, [_c(_setup.XLink, _vm._b({ class: _setup.$style.xBreadcrumbPreviousTitleLink, attrs: { "title": _setup.previousPath.name, "data-testid": _setup.formatTestId("previousLink") } }, "XLink", _setup.previousPath, false), [_c(_setup.XEllipsis, { class: _setup.$style.xBreadcrumbPreviousTitleText }, [_vm._v(" " + _vm._s(_setup.previousPath.name) + " ")])], 1), _c(_setup.XIcon, { class: _setup.$style.xBreadcrumbChevron, attrs: { "icon": "chevron-right", "size": "xs", "data-testid": _setup.formatTestId("previousIcon") } })], 1) : _vm._e()]), _c("span", { class: _setup.$style.xBreadcrumbCurrentTitle, attrs: { "data-testid": _setup.formatTestId("currentPath") } }, [_setup.currentPath.icon ? _c(_setup.XIcon, { class: _setup.$style.xBreadcrumbCurrentTitleIcon, attrs: { "icon-style": _setup.currentPath.iconStyle, "icon": _setup.currentPath.icon, "data-testid": _setup.formatTestId("currentPathIcon") } }) : _vm._e(), _c("h3", { class: _setup.$style.xBreadcrumbCurrentTitleText, attrs: { "title": _setup.currentPath.name, "data-testid": _setup.formatTestId("currentTitle") } }, [_c(_setup.XEllipsis, [_vm._v(" " + _vm._s(_setup.currentPath.name) + " ")])], 1)], 1)]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XBreadCrumb = __component__.exports;
export {
  XBreadCrumb as default
};
